<nav class="px-sm-2 px-0 obrame-left-nav pt-5">

  @if (model && !model.isOnboarded) {
    <a [routerLink]='["/onboarding"]' [routerLinkActive]='["active"]' class="obrame-sidebar-link">
      <fa-icon [fixedWidth]="true" [icon]="faStar" size="lg"></fa-icon>
      Onboarding
    </a>
  } @else {
    <a [routerLink]='["/dashboard"]' [routerLinkActive]='["active"]' class="obrame-sidebar-link">
      <fa-icon [fixedWidth]="true" [icon]="faTableColumns" size="lg"></fa-icon>
      Dashboard
    </a>
    <div class="obrame-sidebar-text">
      <fa-icon [icon]="faUsers" [fixedWidth]="true" class="fixed" size="lg"></fa-icon>
      Members & Teams
    </div>
    <ul class="nav obrame-sidebar flex-column">
      <li class="nav-item">
        <a [routerLink]='["/teams/members"]' [routerLinkActive]='["active"]' class="nav-link">
          <fa-icon [icon]="faUser" [fixedWidth]="true" class="fixed"></fa-icon>
          Members
        </a>
      </li>
      <li class="nav-item">
        <a [routerLink]='["/teams/myteams"]' [routerLinkActive]='["active"]' class="nav-link">
          <fa-icon [icon]="faPeopleGroup" [fixedWidth]="true" class="fixed"></fa-icon>
          My Teams
        </a>
      </li>
    </ul>
  }

  @if (model && model.isPropertyManager) {
    <a class="obrame-sidebar-link" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsedPp"
      aria-controls="collapseExample">
      <fa-icon [fixedWidth]="true" [icon]="faCity" size="lg"></fa-icon>
      Property Management
    </a>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsedPp">
      <ul class="nav obrame-sidebar flex-column">
        <li class="nav-item">
          <a [routerLink]='["/propertyManagement"]' [routerLinkActive]='["active"]' class="nav-link">
            <fa-icon [icon]="faMapLocationDot" [fixedWidth]="true" class="fixed"></fa-icon>
            Properties
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]='["/assignments/propertyOwner"]' [routerLinkActive]='["active"]' class="nav-link">
            <fa-icon [icon]="faClipboardCheck" [fixedWidth]="true" class="fixed"></fa-icon>
            Assignments
          </a>
        </li>
      </ul>
    </div>
  }

  @if (model && model.isServiceProvider) {
    <a class="obrame-sidebar-link" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsedSp"
      aria-controls="collapseSp">
      <fa-icon [fixedWidth]="true" [icon]="faListCheck" size="lg"></fa-icon>
      Service Provider
    </a>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsedSp">
      <ul class="nav obrame-sidebar flex-column">
        <li class="nav-item">
          <a [routerLink]='["/serviceProvider"]' [routerLinkActive]='["active"]' class="nav-link">
            <fa-icon [icon]="faMoneyCheck" [fixedWidth]="true" class="fixed"></fa-icon>
            Pricing and Bio
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]='["/assignments/servicePorvider"]' [routerLinkActive]='["active"]' class="nav-link">
            <fa-icon [icon]="faClipboard" [fixedWidth]="true" class="fixed"></fa-icon>
            Assignments
          </a>
        </li>
      </ul>
    </div>
  }
</nav>